import React from 'react';
import cn from 'classnames';

interface Wrapper {
  alignItems?: 'center' | 'flex-end';
  children: React.ReactNode;
  className?: string;
  flexDirection?: 'column';
  flexWrap?: 'wrap';
  gap?: 4 | 8 | 12 | 24;
  justifyContent?: 'center' | 'flex-end' | 'space-between';
  style?: React.CSSProperties;
}

const Wrapper = ({
  alignItems,
  children,
  className,
  flexDirection,
  flexWrap,
  gap,
  justifyContent,
  style,
}: Wrapper) => (
  <div
    className={cn('whatcrm-widget-wrapper', { [`${className}`]: className })}
    style={{
      ...style,
      alignItems,
      flexDirection,
      flexWrap,
      gap,
      justifyContent,
    }}
  >
    {children}
  </div>
);

export default Wrapper;
